import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import thirdNav from 'website/module/ui/third-nav';

applicationBootstrap().then(() => {
  thirdNav();

  facebookWidgets();

  dropdownLinks();

  roller();
});
